import { useState, useEffect, lazy, Suspense } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const ContactForm = lazy(() => import("@/components/ContactForm"));

/**
 * Global host for the contact form modal. Listens for the
 * "open-contact-form" CustomEvent (optionally with detail.category)
 * so CTAs on any page can open the form.
 */
const ContactModalHost = () => {
  const [contactOpen, setContactOpen] = useState(false);
  const [defaultCategory, setDefaultCategory] = useState("");

  useEffect(() => {
    const handler = (e: Event) => {
      const category = (e as CustomEvent).detail?.category || "";
      setDefaultCategory(category);
      setContactOpen(true);
    };
    window.addEventListener("open-contact-form", handler);
    return () => window.removeEventListener("open-contact-form", handler);
  }, []);

  return (
    <Dialog open={contactOpen} onOpenChange={setContactOpen}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold font-display">Kontaktanfrage</DialogTitle>
          <DialogDescription className="text-muted-foreground text-sm">
            Füllen Sie das Formular aus und wir melden uns bei Ihnen.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          {contactOpen && (
            <Suspense fallback={<div className="h-40" />}>
              <ContactForm key={defaultCategory} defaultCategory={defaultCategory} />
            </Suspense>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactModalHost;
